import { render, staticRenderFns } from "./TaskExamineLayout.vue?vue&type=template&id=7a7eb63b&scoped=true"
import script from "./TaskExamineLayout.vue?vue&type=script&lang=js"
export * from "./TaskExamineLayout.vue?vue&type=script&lang=js"
import style0 from "./TaskExamineLayout.vue?vue&type=style&index=0&id=7a7eb63b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a7eb63b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/crm1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a7eb63b')) {
      api.createRecord('7a7eb63b', component.options)
    } else {
      api.reload('7a7eb63b', component.options)
    }
    module.hot.accept("./TaskExamineLayout.vue?vue&type=template&id=7a7eb63b&scoped=true", function () {
      api.rerender('7a7eb63b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/layout/TaskExamineLayout.vue"
export default component.exports